import { z } from 'zod';

export const VpnStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  Pending: 'Pending',
} as const;

export const VpnStatusSchema = z.enum(VpnStatus);
export type VpnStatus = z.infer<typeof VpnStatusSchema>;

export const VpnConnectionSchema = z.object({
  id: z.string(),
  name: z.string(),
  organizationId: z.string(),
  status: VpnStatusSchema,
  stakeholderEmails: z.array(z.string()).nullable(),
  emailsSentAt: z.string().nullable(),
  created: z.string(),
  updated: z.string(),
});
export type VpnConnection = z.infer<typeof VpnConnectionSchema>;

export const CreateValuesSchema = z.object({
  name: z.string(),
  organizationId: z.string(),
  stakeholderEmails: z.array(z.string()).optional(),
});
export type CreateValues = z.infer<typeof CreateValuesSchema>;
